import Box from "@mui/material/Box";
import { CardMedia } from "@mui/material";
import { styled } from "@mui/material/styles";

export const LogoCardMedia = styled(CardMedia)(
  ({ theme, isLandscape, originalWidth = 350, originalHeight = 191 }) => ({
    objectFit: "inherit", // more typical for images
    height: originalHeight,
    width: originalWidth,

    [theme.breakpoints.down("md")]: {
      height: originalHeight - 40,
      width: originalWidth - 40,
    },

    "@media (max-width:401px)": {
      width: 170,
      height: (170 / originalWidth) * originalHeight,
    },
    "@media (max-width:395px)": {
      width: 165 + 80,
      height: (165 / originalWidth) * originalHeight + 40,
    },
    "@media (max-width:389px)": {
      width: 150 + 80,
      height: (150 / originalWidth) * originalHeight + 40,
    },
    "@media (max-width:355px)": {
      width: 110 + 80,
      height: (110 / originalWidth) * originalHeight + 40,
    },
    "@media (max-width:319px)": {
      width: 90 + 80,
      height: (90 / originalWidth) * originalHeight,
    },
  })
);

export const Logo = () => (
  <Box
    display={"flex"}
    justifyContent={"center"}
    alignItems={"center"}
    marginTop={3.5}
  >
    <LogoCardMedia
      component="img"
      image={require("../../assets/idjshow.png")}
    />
  </Box>
);
